"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgManagerEdit(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#fff"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M15.729 4.268l.118.118a1.5 1.5 0 010 2.12l-9.312 9.312-2.766.528.527-2.767 9.311-9.311a1.5 1.5 0 012.122 0zm-8.646 8.649L12.5 7.5m-8.333 6.25c.833-.139 2.5.083 2.5 2.083M12.917 5c.833-.139 2.5.833 2.083 2.5"
  }));
}

var MemoSvgManagerEdit = /*#__PURE__*/React.memo(SvgManagerEdit);
var _default = MemoSvgManagerEdit;
exports["default"] = _default;